import actionTypes from "../actionTypes";
import config from "../../config";

const GUARD_NAME = "ldap";

export const getPermissions = () => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.PERMISSIONS_FETCH,
  url: config.api.grantUrl + "/permissions"
});

export const postPermission = (name, description) => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.PERMISSION_POST,
  url: config.api.grantUrl + "/permissions",
  options: {
    method: "POST",
    body: JSON.stringify({ name, description, guard_name: GUARD_NAME })
  }
});

export const deletePermission = permission => ({
  type: actionTypes.app.API_FETCH,
  start: actionTypes.PERMISSION_DELETE,
  url: config.api.grantUrl + "/permissions/" + permission.id,
  options: {
    method: "DELETE"
  },
  payload: {
    permission
  }
});

export const deletePermissionFromRole = (permission, role) => ({
  type: actionTypes.app.API_FETCH,
  start: actionTypes.PERMISSION_DELETE_FROM_ROLE,
  url:
    config.api.grantUrl + "/permissions/" + permission.id + "/roles/" + role.id,
  options: {
    method: "DELETE"
  },
  payload: {
    permission,
    role
  }
});

export const putPermissionToRole = (permission, role) => ({
  type: actionTypes.app.API_FETCH,
  start: actionTypes.PERMISSION_PUT_TO_ROLE,
  url:
    config.api.grantUrl + "/permissions/" + permission.id + "/roles/" + role.id,
  options: {
    method: "PUT"
  },
  payload: {
    permission,
    role
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/Permissions.js